
/**
 * @fileOverview Tabs module definition
 *
 * ***Note that there is a wrapper here to namespace require
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/Tabs',['require','jquery','lib/Util','GlobalEventDispatcher','GlobalResizeListener'],function(require) {

        var $ = require('jquery');
        var Util = require('lib/Util');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');
        var GlobalResizeListener = require('GlobalResizeListener');

        /**
         * A view script that controls tabs. This is used in the localization tabs and for the All Products Page.
         *
         * @class Tabs
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        $debug('Tabs loaded - use ?debug=tabs for messages');
        var Tabs = function($element) {
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application
            this.globalResizeListener = GlobalResizeListener.getResizeListener();

            /**
             * A reference to the containing DOM element
             *
             * @default null
             * @property $element
             * @type {jQuery}
             * @public
             */
            this.$element = $($element);
            
            if (urlHash['highlight'] === 'true'){
                this.$element.css('border','3px solid blue');
            }
            
            $debug('Tabs Present... highlighting with border of blue', 'tabs');
            

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @property isEnabled
             * @type {bool}
             * @public
             */
            this.isEnabled = false;

            this.init();
        };

        /**
         *
         * This takes in data options from the markup and overwrites base values. If there is no value in the data
         * options tag then defaults are shown below.
         *
         * @method setOptions
         * @returns {Tabs}
         * @private
         */

        Tabs.prototype.setOptions = function() {
            var options = this.$element.data().options;

            var defaults = {
                activeClass : 'MMM--tabs_isActive',
                inactiveClass : 'MMM--tabs_isInactive',
                JSTabsClass : 'MMM--tabs_hidden'
            };
            this.settings = $.extend({}, defaults, options);
            
            if (urlHash['debug'] === 'tabs'){
                //output debug items
                $debug('     Tab Options ', 'tabs');
                $debug('          HTML data-options Settings: ' + $printObj(options),'tabs');
                $debug('          Default Settings: ' + $printObj(defaults),'tabs');
                $debug('          Combined Settings: ' + $printObj(this.settings),'tabs');
                $debug('','tabs');
                $debug('','tabs');
                //end debug block
            }
            return this;
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         * @method init
         * @returns {Tabs}
         * @private
         */
        Tabs.prototype.init = function() {
            this.setOptions()
                .setupHandlers()
                .createChildren()
                .layout()
                .enable();

            return this;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @method setupHandlers
         * @returns {Tabs}
         * @private
         */
        Tabs.prototype.setupHandlers = function() {
            // Bind event handlers scope here
            this.onClickHandler = this.onClick.bind(this);

            return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @returns {Tabs}
         * @private
         */
        Tabs.prototype.createChildren = function() {
            this.$tabTrigger = this.$element.find('.js-tabs-triggers');
            $(this.$tabTrigger).attr('role', 'tablist')
            this.$tabPanels = this.$element.find('.js-tab-panels');
            return this;
        };

        /**
         * Remove any child objects or references to DOM elements
         *
         * @method removeChildren
         * @returns {Tabs}
         * @public
         */
        Tabs.prototype.removeChildren = function() {
            this.$tabTrigger = null;
            this.$tabPanels = null;

            return this;
        };

        /**
         * Performs measurements and applies any positioning style logic
         * Should be run anytime the parent layout changes
         *
         * @method layout
         * @returns {Tabs}
         * @public
         */
        Tabs.prototype.layout = function() {
            this.$tabTrigger.addClass(this.settings.JSTabsClass);
            this.$tabTrigger.children('li').attr('role', 'tab');
            this.$tabTrigger.children('li').not('.MMM--products-tabs_isActive').attr('aria-selected', 'false');
            this.$tabTrigger.children('li.MMM--products-tabs_isActive').attr('aria-selected', 'true');
            this.$tabPanels.children('li').not(':first').addClass(this.settings.inactiveClass);

            return this;
        };

        /**
         * Enables the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {Tabs}
         * @public
         */
        Tabs.prototype.enable = function() {
            var self = this;
            var isTouchMoving;

            if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;


            this.$tabTrigger.on('click', 'li', this.onClickHandler);

            return this;
        };

        /**
         * Disables the component
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @property disable
         * @returns {Tabs}
         * @public
         */
        Tabs.prototype.disable = function() {
            if (!this.isEnabled) {
                return this;
            }
            this.isEnabled = false;

            this.$tabTrigger.off('click', 'li', this.onClickHandler);

            return this;
        };

        /**
         * Destroys the component
         * Tears down any events, handlers, elements
         * Should be called when the object should be left unused
         *
         * @method destroy
         * @returns {Tabs}
         * @public
         */
        Tabs.prototype.destroy = function() {
            this.disable()
                .removeChildren();

            return this;
        };

        //////////////////////////////////////////////////////////////////////////////////
        // EVENT HANDLERS
        //////////////////////////////////////////////////////////////////////////////////

        /**
         * onClick handler
         * Gets index of target tab, calls the clearActive method. Then it adds the
         * activeClass to the tab that was clicked. After which it passes the index into
         * the displayPanel method.
         *
         * @method onClick
         * @param {Event} e JavaScript event object
         * @private
         */
        Tabs.prototype.onClick = function(e) {
            $debug('**** Tab Clicked **** ', 'tabs');
            if (e.preventDefault) {
                e.preventDefault();
            }
            else {
                //needed for IE Support
                e.returnValue = false;
            }
            var $clickedTab = $(e.currentTarget);
            var clickedTabPosition = $clickedTab.index();

            $debug('Clicked Tab = ' + $.trim($clickedTab.text()), 'tabs');
            $debug('Clicked Tab Position = ' + clickedTabPosition, 'tabs');
            this.clearActive();
            $clickedTab.addClass(this.settings.activeClass)
            $clickedTab.attr('aria-selected', 'true');
            $debug('Adding Class of ' + this.settings.activeClass + ' to ' + $.trim($clickedTab.text()), 'tabs');
            if (urlHash['highlight'] === 'true'){
                $clickedTab.css('border', '2px solid green');
            }

            this.displayPanel(clickedTabPosition);
        };

        //////////////////////////////////////////////////////////////////////////////////
        // HELPERS
        //////////////////////////////////////////////////////////////////////////////////

        /**
         * Clear Active States
         * This method finds the active panels and adds the inactive class. After which it
         * removes active classes from all the tabs and panels.
         *
         * @method clearActive
         * @private
         */

        Tabs.prototype.clearActive = function() {
            $debug('Clearing Active Tabs...', 'tabs');
            this.$tabPanels.children('.' + this.settings.activeClass).addClass(this.settings.inactiveClass);
            this.$element.find('.' + this.settings.activeClass).attr('aria-selected', 'false');
            this.$element.find('.' + this.settings.activeClass).removeClass(this.settings.activeClass);
            
			// If the target contains an inline video player, we need to pause it
			if(typeof videoMods !== 'undefined') {
				$debug('Found inline video module array...', 'tabs');

				for(var i=0, l=videoMods.length; i<l; i++) {
					$debug('Checking to see if video with video ID "' + videoMods[i].videoID + '" is contained in this tabs instance...', 'tabs');

					if($.contains(this.$element[0], videoMods[i].$parentComponent[0])) {
						$debug('Tabs instance does contain inline video player video ID "' + videoMods[i].videoID + '", unloading player...', 'tabs');

						videoMods[i].unloadPlayer();
					}
				}
			}
        };

        /**
         * Display Panel
         * This method takes in the index passed into it from the onClick method. The next
         * step is it finds the 'li' with the same index then adds the activeClass and
         * removes the inactiveClass.
         *
         * @method displayPanel
         * @param {int} clickedTabPosition
         * @private
         */
        Tabs.prototype.displayPanel = function(clickedTabPosition) {
            $debug('Displaying Panel ' + clickedTabPosition, 'tabs');
            this.$tabPanels.children('li').eq(clickedTabPosition).addClass(this.settings.activeClass).removeClass(this.settings.inactiveClass);

            if (urlHash['highlight'] === 'true'){
                this.$tabPanels.children('li').eq(clickedTabPosition).css('border', '3px solid red');
            }
            
            this.eventDispatcher.publish('Container State Change'); // Publish event for other modules to fire resize methods if needed

            $debug('Added class of ' + this.settings.activeClass + ' to tab # ' + clickedTabPosition, 'tabs');
        };

        return Tabs;
    });

}(MMMRequire));

